import axios from "axios";
import { API_BASE } from "@/lib/api";
import { scanResume } from "@/lib/resumeScan";

const KEY = "rpopro_fit_scan_used";
export const savedFit = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };

const utm = () => {
  const p = new URLSearchParams(window.location.search);
  return ["utm_source", "utm_medium", "utm_campaign", "ref"].reduce((o, k) => (p.get(k) ? { ...o, [k]: p.get(k) } : o), {});
};

// POST /public/campaign/resume-fit (spec §25); falls back to the live general scan with no job fit.
export const fitScan = async ({ file, text, target_role }) => {
  const fd = new FormData();
  if (file) fd.append("file", file);
  if (text) fd.append("text", text);
  fd.append("target_role", target_role);
  Object.entries(utm()).forEach(([k, v]) => fd.append(k, v));
  let r;
  try {
    const { data } = await axios.post(`${API_BASE}/public/campaign/resume-fit`, fd);
    r = { ...data, ai: true };
  } catch (e) {
    const s = e.response?.status;
    if (s && s !== 404 && s < 500) {
      const d = e.response?.data?.detail;
      throw new Error(typeof d === "string" ? d : s === 429 ? "The scanner is busy right now. Please try again in a minute." : "We couldn't read that resume. Try a PDF or DOCX, or paste the text.");
    }
    r = { ...(await scanResume({ file, text })), fit: null };
  }
  r.target_role = target_role;
  localStorage.setItem(KEY, JSON.stringify(r));
  localStorage.setItem("rpopro_target_role", target_role);
  return r;
};
